<template>
	<main>
		<TopBottomLayout v-if="hotrankingCategoryData" class="c_not-center">
			<div v-for="(item, index) in hotrankingCategoryData" :key="index" class="ly_col-48 ly_wrapper">
				<div v-for="(key, keyIndex) in Object.keys(item)" :key="keyIndex" class="main_title ly_col-24 c_responsive">
					<h4>{{ key }}</h4>
					<HotRankSlideList :data="item[key]" />
				</div>
				<div v-if="hotrankingTabData" class="ly_col-48 ly_list-wrapper">
					<div
						v-if="displayStore.isDesktop && hotrankingTabData.hot_ranking_banner.hot_ranking_banner_image_pc_path"
						class="banner_hot-ranking c_responsive"
					>
						<img
							:src="hotrankingTabData?.hot_ranking_banner.hot_ranking_banner_image_pc_path"
							@click="clickBanner(hotrankingTabData?.hot_ranking_banner.hot_ranking_url)"
						/>
					</div>
					<div
						v-if="!displayStore.isDesktop && hotrankingTabData.hot_ranking_banner.hot_ranking_banner_image_mo_path"
						class="banner_hot-ranking c_responsive"
					>
						<img
							:src="hotrankingTabData?.hot_ranking_banner.hot_ranking_banner_image_mo_path"
							@click="clickBanner(hotrankingTabData?.hot_ranking_banner.hot_ranking_url)"
						/>
					</div>
					<MarketTimingLayout class="ly_list-wrapper">
						<StickyTabBar
							v-if="Object.keys(hotrankingTabData?.hot_ranking_tab).length > 0"
							:items="Object.keys(hotrankingTabData?.hot_ranking_tab)"
						></StickyTabBar>
						<!-- <CategoryBar :items="hotrankingTabData?.hot_ranking_tab[String(selectedTab)]" query-key="1" /> -->
						<ListLayout v-if="hotRankingData" :class="['c_responsive', hotRankingData?.length <= 0 && 'ly_list']">
							<template v-if="hotRankingData?.length > 0">
								<HotRankDetailList
									v-if="hotRankingData?.length > 0"
									:items="hotRankingData"
									@update:book-mark-refetch="onClickRefetchData"
								/>
								<!-- <MoreButton /> -->
							</template>
							<p v-else class="not_content">등록된 데이터가 없습니다.</p>
						</ListLayout>
						<!-- <GuideLayout v-else>
							<div class="ly_col-16">
								<div class="guide_img_box"><img src="@/assets/img/common/exclamation.png" alt="notcomplete" /></div>
								<div class="guide_content">
									<p class="guide_content_top">
										최근 성장이 돋보이는 섹터, 저평가,고배당 등<br class="display_none" />
										<strong> 특정 키워드에 부합한 종목 </strong>들을 쉽게 확인할 수 있습니다.
									</p>

									<p class="guide_content_top"><strong> 7인 구독자 대상 </strong>에게 제공되는 서비스입니다.</p>
								</div>
							</div>

							<div class="btn_box">
								<button class="c_button mid">서비스 안내</button>
								<button class="c_button primary-fill" @click="$router.push('/payment')">구독하기</button>
							</div>
						</GuideLayout> -->
					</MarketTimingLayout>
				</div>
			</div>
		</TopBottomLayout>
	</main>
</template>
<script setup lang="ts">
// component
import { computed } from 'vue';
// core
import { useRoute } from 'vue-router';

// api
import { useGetHotrankingApi_JPN, useGetHotrankingCategoryApi_JPN, useGetHotrankingTabApi_JPN } from '@/api/hotRanking';
// import MoreButton from '@/components/atom/button/MoreButton.vue';
import StickyTabBar from '@/components/atom/tabBar/StickyTabBar.vue';
import HotRankDetailList from '@/components/hotRank/HotRankDetailList.vue';
// import GuideLayout from '@/components/layout/main/GuideLayout.vue';
import ListLayout from '@/components/layout/main/ListLayout.vue';
import MarketTimingLayout from '@/components/layout/main/MarketTimingLayout.vue';
import TopBottomLayout from '@/components/layout/main/TopBottomLayout.vue';
import HotRankSlideList from '@/components/rankList/HotRankSlideList.vue';
import { useDisplayStore } from '@/stores/display';

// -----variable-----
const route = useRoute();
const displayStore = useDisplayStore();

const pk = computed(() => route.params.pk ?? '');
const selectedTab = computed(() => {
	return route.query.tab ?? (hotrankingTabData?.value && Object.keys(hotrankingTabData?.value.hot_ranking_tab)[0]);
});
const categoryPk = computed(() => route.params.categoryPk ?? '');
// -----api-----
const { data: hotrankingCategoryData } = useGetHotrankingCategoryApi_JPN(
	computed(() => ({ hot_ranking_category_pk: String(categoryPk.value) }))
);
const { data: hotrankingTabData } = useGetHotrankingTabApi_JPN(computed(() => ({ hot_ranking_pk: String(pk.value) })));

const { data: hotRankingData, refetch: hotRankingDataRefetch } = useGetHotrankingApi_JPN(
	computed(() => ({
		hot_ranking_pk: String(pk.value),
		division_top: selectedTab.value ? String(selectedTab.value) : '',
	})),
	computed(() => !!hotrankingTabData.value)
);
//-----function-----
const onClickRefetchData = async () => {
	await hotRankingDataRefetch();
};
const clickBanner = (url: string) => {
	let agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick) {
		window.location.href = url;
	} else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.nativeUrlOpenBrowser
	) {
		window.location.href = url;
	} else {
		window.open(url, '_self');
	}
};
</script>

<style lang="scss" scoped>
.guide_img_box {
	width: 12rem;
}
.guide_content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
	font-size: var(--font-s-regular);
	font-weight: var(--font-w-light);
	line-height: 2.1rem;
	&_top {
		text-align: center;
		line-height: 2.3rem;
	}
	strong {
		color: var(--color-primary);
		line-height: 2.1rem;
	}
}
.btn_box {
	display: flex;
	width: 100%;
	gap: 1rem;
	button {
		flex: 1;
		padding: 1.3rem 1.6rem;
		height: 5.2rem;
		border-radius: var(--border-radius-x-small);
		font-weight: var(--font-w-semi-bold);
	}
}
.display_none {
	@media screen and (max-width: 420px) {
		display: none;
	}
}
.ly_col-16 {
	justify-content: center;
	align-items: center;
}
.banner_hot-ranking {
	height: 18rem;
	border-radius: 0.8rem;
	/* overflow: hidden; */
	cursor: pointer;
	@media screen and (max-width: 1280px) {
		height: 12rem;
	}
	img {
		height: 100%;
		object-fit: fill;
		object-position: center;
		border-radius: 0.8rem;
	}
}
.not_content {
	font-size: var(--font-s-mid);
	font-weight: var(--font-w-semi-bold);
	line-height: normal;
	text-align: center;
}
main {
	display: flex;
	/* height: 100%; */
}
.c_not-center {
	justify-content: unset;
	display: flex;
	flex: 1;
}
.ly_wrapper {
	height: 100%;
}
.ly_list-wrapper {
	height: 100%;
}
.ly_list {
	height: 100%;
	justify-content: center;
}
</style>
